/* eslint-disable */



function init(selector) {
  var elts = $(selector);

  elts.each(function () {
    var elt = $(this);
    var relElt = $(elt.attr('href'));
    var arrowElt = elt.find('.arrow');

    elt.click(function (e) {
      e.preventDefault();
      if (relElt.hasClass('toggle-content-show')) {
        relElt.removeClass('toggle-content-show');
        arrowElt.removeClass('rotate-90');
      } else {
        relElt.addClass('toggle-content-show');
        arrowElt.addClass('rotate-90');
      }
    });
  });
}

module.exports = init;
